import { render, staticRenderFns } from "./PickReportform.vue?vue&type=template&id=71cc6fd2&scoped=true&"
import script from "./PickReportform.vue?vue&type=script&lang=js&"
export * from "./PickReportform.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71cc6fd2",
  null
  
)

export default component.exports